import { DisclosureButton } from '@headlessui/react';

import Props from '@/components/@base/accordion/button/type';
import cn from '@/lib/clsxm';

export default function Button({ children,className, ...props }: Props) {
  return <DisclosureButton className={cn('cursor-pointer',className)} {...props}>{children}</DisclosureButton>;
}
